import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { LinearAuthorizeSchema, LinearDisconnectSchema, LinearStatusSchema } from '../schemas/linear';

const headers = {
	'Key-Inflection': 'camel',
};

const linearKeys = {
	all: ['linear'] as const,
	status: () => [...linearKeys.all, 'status'] as const,
};

const linearPaths = {
	status: () => '/linear/status',
	authorize: () => '/linear/authorize',
	disconnect: () => '/linear/disconnect',
};

export const useLinearStatus = () => {
	const http = useHttpClient();
	return useQuery({
		queryKey: linearKeys.status(),
		queryFn: async () => {
			const res = await http.get(linearPaths.status(), { headers });
			return LinearStatusSchema.parse(res.data);
		},
	});
};

export const useLinearAuthorize = () => {
	const http = useHttpClient();
	return useMutation({
		mutationFn: async (returnPath?: string) => {
			const res = await http.get(linearPaths.authorize(), {
				headers,
				params: returnPath ? { return_path: returnPath } : undefined,
			});
			return LinearAuthorizeSchema.parse(res.data);
		},
	});
};

export const useLinearDisconnect = () => {
	const http = useHttpClient();
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async () => {
			const res = await http.delete(linearPaths.disconnect(), { headers });
			return LinearDisconnectSchema.parse(res.data);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: linearKeys.all });
		},
	});
};
